import { render, staticRenderFns } from "./indexold.vue?vue&type=template&id=5235fe6c&"
import script from "./indexold.vue?vue&type=script&lang=js&"
export * from "./indexold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports